module.exports = __webpack_public_path__ + "img/map_Z3.4.B.02.1b91f6ea.svg";